import React, { useMemo, useState } from 'react';
import { GameHelp } from './components/GameHelp/GameHelp';
import { RecentlyPlayed } from './components/RecentlyPlayed/RecentlyPlayed';
import { DashboardToggle } from './components/DashboardToggle/DashboardToggle';
import { UserDetails } from './components/UserDetails/UserDetails';
import { DraggableContainerWrapper } from '@/features/DraggableContainer/DraggableContainerWrapper';
import './styles/dashboard.scss';
import { DashboardIcon } from '@/features/Icons/DashboardIcon.tsx';
import { GameHelpIcon } from '@/features/Icons/GameHelpIcon.tsx';
import { useAppOrientation } from '@/lostHooks/orientation/useOrientation';

type TabType = 'dashboard' | 'game_help';

export interface TabItem {
  type: TabType;
  title: string;
  icon: React.ReactNode;
  iconTitle: React.ReactNode;
}

const getIconSize = (
  orientation: 'portrait' | 'landscape' | undefined,
): string => {
  if (orientation === 'portrait' || orientation === 'landscape') {
    return '27';
  }
  return '32.25';
};

export default function Dashboard() {
  const [activeTab, setActiveTab] = useState<TabType>('dashboard');
  const orientation = useAppOrientation();
  const iconSize = getIconSize(orientation);

  const tabs: TabItem[] = useMemo(
    () => [
      {
        type: 'dashboard',
        title: 'Dashboard',
        icon: <DashboardIcon size={iconSize} />,
        iconTitle: <DashboardIcon size={49} />,
      },
      {
        type: 'game_help',
        title: 'Game Help',
        icon: <GameHelpIcon size={iconSize} />,
        iconTitle: <GameHelpIcon size={49} />,
      },
    ],
    [iconSize],
  );

  return (
    <div className="game-window-content">
      <div className="game-window-content__header">
        {tabs[activeTab === 'dashboard' ? 0 : 1].iconTitle}
        {tabs[activeTab === 'dashboard' ? 0 : 1].title}
      </div>
      <div className="game-window-content__body">
        <DraggableContainerWrapper>
          <DashboardToggle
            activeTab={activeTab}
            onTabChange={setActiveTab}
            tabs={tabs}
          />
        </DraggableContainerWrapper>
        <div className="content">
          <DraggableContainerWrapper>
            {activeTab === 'dashboard' && (
              <>
                <UserDetails />
                <RecentlyPlayed />
              </>
            )}
            {activeTab === 'game_help' && <GameHelp />}
          </DraggableContainerWrapper>
        </div>
      </div>
    </div>
  );
}
